
function fnCounter() {
    var a = 0;
    if ($('.counter').length ) {
        $(window).scroll(function () {
            var oTop = $(".counter").offset().top - window.innerHeight;
            if (a == 0 && $(window).scrollTop() > oTop) {
                $(".counter").each(function () {
                    var $this = $(this),
                        countTo = $this.attr("data-target");
                    $({
                        countNum: $this.text()
                    }).animate(
                        {
                            countNum: countTo
                        },

                        {
                            duration: 4000,
                            easing: "swing",
                            step: function () {
                                //$this.text(Math.ceil(this.countNum));
                                $this.text(
                                    Math.ceil(this.countNum).toLocaleString("en")
                                );
                            },
                            complete: function () {
                                $this.text(
                                    Math.ceil(this.countNum).toLocaleString("en")
                                );
                                //alert('finished');
                            }
                        }
                    );
                });
                a = 1;
            }
        });
    }
}